import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Lesson } from '../models/lesson.model';

@Injectable({
  providedIn: 'root'
})
export class StoriesService {

  public apiBase = `${environment.apiBaseUrl}/story`;

  constructor(private http: HttpClient) { }

  getStories(language: string): Observable<any> {
    const page = 1;
    const size = 20;
    const lang = language;
    const url = `${this.apiBase}?page=${page}&size=${size}&lang=${lang}`;

    return this.http.get(url);
  }
}
